import styled from "styled-components";

export const Container = styled.div`
  cursor: pointer;
  &:hover{
    opacity: 0.9;
  }
`;
